<template>
  <div v-if="loaded">
    <div v-if="!is_user_can_watch">
        <div id="unactive_screen" v-if="show_dets">
        <!-- <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div> -->
        <div id="go_back_btn" class="tov_animate" @click="$router.go(-1)"><i class="material-icons dp48">keyboard_arrow_right</i></div>

        <div class="inner">
          <div style="color:#c12026;">
            <div><b v-text="'היי ' + user_data.display_name + '.'"></b></div>
            <p>תוכן זה חסום לסוג המנוי שלך</p>
            <div>רוצה לצפות בכל התכנים בTOV?</div>
          
            <a class="btn" @click="$emit('open_pay')"> הפכו לפרימיום</a>
          </div>

        </div>
      </div>
    </div>

  <div v-if="is_user_can_watch">

  <div id="video_page" :class="(is_user_active ? 'user_active' : 'user_inactive')" @mousemove="user_hover()" @touchmove="user_hover()">

    <div id="unactive_screen" v-if="!is_country_can_watch">
      <div class="bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
      <router-link to="/" id="go_back_btn" class="tov_animate"><i class="material-icons dp48">keyboard_arrow_right</i></router-link>

      <div class="inner">
        <div style="color:#c12026;">
          <div><b>היי {{user_data.display_name}}.</b></div>
          לצערנו השירות לא פועל במדינה שבה אתה נמצא.<br>
        </div>


      </div>
    </div>

    <div id="video_wrapper" @mouseover="show_controls = true" @mouseleave="show_controls = false" v-if="is_user_can_watch">
      
          <div id="go_back_btn" class="tov_animate" @click="$router.go(-1)"><i class="material-icons dp48">keyboard_arrow_right</i></div>

<!-- 
          <div id="movie_titles">
            <h3 v-text="item.title"></h3>
            <h4 v-if="item.title != episode.title" v-text="episode.title"></h4>
          </div> -->

          <video ref="videoPlayer" class="video-js" autoplay></video>
          
    </div>

  </div>
  </div>
   <md-dialog-prompt
      :md-active.sync="active_problam"
      v-model="problam_val"
      md-title="בואו תספרו לנו מה הבעיה?"
      md-input-maxlength="150"
      md-input-placeholder="הקלד/י את הבעיה..."
      @md-confirm="onConfirm_problam()"
      md-confirm-text="שלח"
      md-cancel-text="בטל" />
  </div>
</template>

<script>
import videojs from 'video.js';

require('video.js/dist/video-js.min.css');
// videojs-hotkeys temporarily disabled due to compatibility issues
// require('videojs-hotkeys');

export default {

  props: ["user_data", "profile","country_code"],
  data() {
    return {
      updateInterval: false,
      user_token: localStorage.getItem('user_token'),
      user_watch_time: 0,
      status: "",
      link: "/info/",
      coupon: "",
      problam_val: "",
      active_problam: false,
      coupon_active: false,
      show: true,
      show_dets: true,
      is_user_active: false,
      is_user_active_timer: null,
      show_controls: false,
      player: null,
      loaded: false,
      id: this.$route.params.id,
      eid: this.$route.params.eid,
      videoOptions: {
        autoplay: true, 
            controls: true,
            sources: [
                {
                    src: '', // this.episode.video,
                    type: "video/mp4"
                }
            ]
      },
      episodes: {},
      episode: false,
      start_hour_unix: 0,
      liveCurrTime: Math.floor(Date.now() / 1000),
    };
  },
  computed: {
    is_user_can_watch(){
      //if (this.episode.is_premium == '0') return true;
      if (this.get_me.is_active == true ) return true;
      //if (this.get_me.user_status == 'active' ) return true;
      return true;
    },

    is_country_can_watch(){
      return true;
      // return (this.country_code == 'IL');
    }
    
  },
  methods: {
      liveCheck(){
        for (let i in this.episodes)
        {
            let item = this.episodes[i];
            //console.log({start: item.start_hour_unix, end: item.end_hour_unix})

            if ((!this.episode || item.id != this.episode.id) && item.start_hour_unix <= this.liveCurrTime && item.end_hour_unix > this.liveCurrTime)
            {  
                //setTimeout(function(){ self.player.currentTime(newValue); = self.episode.user_duration; }, 200);
                //console.log(item)
                // console.log('Changed - ' + item.name)
                return this.episode = item;
            }
        }
       // console.log(false)
        
        return {id: 0};
      },
   onConfirm_problam(){
     var self = this;
        this.api_call({ url: 'problem', data: { uid: this.get_me.id, eid: this.eid ,message:this.problam_val}, onComplete: function(){
        self.$alert("הודעתך נשלחה בהצלחה!");
        }})
   },

    user_hover(){
      var self = this;
      self.is_user_active = true;

      window.clearTimeout(this.is_user_active_timer);

      this.is_user_active_timer = setTimeout(() => {
        self.is_user_active = false;
      }, 2400);
    },


    player_first_init(){

        var self = this;
        
        self.videoOptions.controlBar= {
            children: ['LiveDisplay', 'CustomControlSpacer', 'PlaybackRateMenuButton', 'AudioTrackButton']
        }

        self.videoOptions.sources = [ ];
        videojs.addLanguage('en', { "captions off": "ללא כתוביות" });

        self.player = videojs(self.$refs.videoPlayer, self.videoOptions, function onPlayerReady() {

          self.player.on('timeupdate', function(){ 
        

          });

        });


      var problam_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function(){
          self.active_problam = true;
          }
      });

      // LEFT GROUP 
      self.player.controlBar.left_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.left_group.addClass('left_group');

      self.player.controlBar.left_group.addChild('FullscreenToggle');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild('PictureInPictureToggle');
      self.player.controlBar.left_group.addChild('SubsCapsButton');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild('VolumePanel');
      if (!self.is_mobile()) self.player.controlBar.left_group.addChild(new problam_btn()).addClass('problam_btn');

      self.player.controlBar.el().append(
        self.player.controlBar.left_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );


      // CENTER GROUP
      self.player.controlBar.center_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.center_group.addClass('center_group');

      
      self.player.controlBar.center_group.addChild('PlayToggle');

      self.player.controlBar.el().append(
        self.player.controlBar.center_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );

      // RIGHT GROUP
      self.player.controlBar.right_group = self.player.controlBar.addChild('Component');
      self.player.controlBar.right_group.addClass('right_group');

      self.player.controlBar.el().append(
        self.player.controlBar.right_group.el(),
        self.player.controlBar.el().firstChild.nextSibling
      );
      
    },
  

    player_change(){

        if (!this.is_user_can_watch) return;
        if (!this.episode) return;

        var self = this;
        //self.videoOptions.poster = self.episode.pic_thumb_parsed;

          self.player.src([
            { 
            src: (self.episode.video != '' ? self.episode.video : ''),
            type: (self.episode.video.search('m3u8') != -1 ? "application/x-mpegURL" : 'video/mp4')
            }
        ]);

        for (let i in self.episode.srt_list)
        {

        let srt = self.episode.srt_list[i];

        self.player.addRemoteTextTrack({ 
            label: srt.name , 
            kind: 'subtitles',
            language: srt.key,
            src: srt.url, //'https://storage.netflix.bagelcms.com/texttracks/upc-video-subtitles-en.vtt.txt', 
            default: true
        });

       
        // break;
        }
        
        let startTime = self.liveCurrTime - self.episode.start_hour_unix
        if (startTime > 10) self.player.currentTime(startTime);
    
    },
  },   

    beforeDestroy() {
        if (this.player) this.player.dispose();
    },
  mounted() {

    var self = this;
    self.$emit('show_loader');
      
    // promoted
    this.api_call({ url: 'items/get_live', data: { id: this.id }, onComplete: function(data){
  
      self.start_hour_unix = data.data.data.start_hour_unix;
      self.episodes = data.data.data.episodes;

        setInterval(() => { 
            self.liveCurrTime = Math.floor(Date.now() / 1000); 

            self.liveCheck();
        }, 1000);

      self.loaded = true;
      self.$emit('loaded');
      
       setTimeout(() => {
         self.player_first_init(); 
       }, 300);   
      
       
      } } );
    
  },
  watch:{
      episode(){
          //console.log('blatt')
            
        setTimeout(() => {
          this.player_change(); 
        }, 300);  

          //alert(3);
      }
  }
}
</script>

<style lang="scss">
#go_back_btn{padding: 0 !important;    position: absolute;top: 0 !important;right: 0;z-index: 5;height: 50px;width: 50px;background: #fff;color: #000;text-align: center;line-height: 62px;cursor: pointer;}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#unactive_screen{width: 50%;margin: 0 auto;padding: 30px;margin-top: 100px;text-align: center;font-size: 25px;}
.container { position: relative; height: 400px; overflow: auto; }

@media(max-width: 900px) {
  #unactive_screen{width: 90% !important;margin: 0 auto;padding: 30px;margin-top: 100px;text-align: center;font-size: 25px;}
}
</style>